import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ModalActionConfirmation = ({ isOpen, toggle, action, onConfirm }) => {
    console.log("action", action)
    return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Confirmation</ModalHeader>
      <ModalBody>{action?.action?.confirm || "Êtes-vous sûr de vouloir effectuer cette action ?"}</ModalBody>
      <ModalFooter>
        <Button 
          color="primary" 
          onClick={() => {
            onConfirm(action?.action);
            toggle();
          }}
        >
          Confirmer
        </Button>
        <Button color="secondary" onClick={toggle}>
          Annuler
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalActionConfirmation;